(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["av-cart-experience"] && !Shopify.designMode) return;
  try {
    (() => {
    let discountTimer;
    const requestDiscount = () => {
      clearTimeout(discountTimer);
      discountTimer = setTimeout(() => {
        if (typeof window.bndlr?.updateCartDiscounts === 'function') window.bndlr.updateCartDiscounts();
      }, 150);
    };
    const identity = items => items.map(item => `${item.key || item.variant_id || item.id}:${Number(item.quantity)}`).sort().join('|');
    if (!customElements.get('av-cart-summary')) {
      customElements.define('av-cart-summary', class extends HTMLElement {
        connectedCallback() {
          this.lines = JSON.parse(this.querySelector('[data-cart-lines]').textContent);
          this.onDiscount = event => {
            const quote = event.detail;
            const current = Number(this.dataset.subtotal);
            const total = Number(quote?.total_amount_discounted);
            if (!quote?.original_cart_object?.items || identity(quote.original_cart_object.items) !== identity(this.lines)) return;
            if (!Number.isFinite(total) || total < 0 || total >= current) return;
            const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' }).format(value / 100);
            this.querySelector('[data-av-cart-total]').textContent = money(total);
            const savings = this.querySelector('[data-av-cart-savings]');
            savings.textContent = `${this.dataset.savingsLabel} ${money(current - total)}`;
            savings.hidden = false;
          };
          document.addEventListener('bundler:total_cart_values', this.onDiscount);
          document.addEventListener('bundler:loaded', requestDiscount);
          requestDiscount();
        }
        disconnectedCallback() {
          document.removeEventListener('bundler:total_cart_values', this.onDiscount);
          document.removeEventListener('bundler:loaded', requestDiscount);
        }
      });
    }
    if (!customElements.get('av-cart-upgrade')) {
      customElements.define('av-cart-upgrade', class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.error = this.querySelector('[role="alert"]');
          this.label = this.button.textContent;
          this.plans = JSON.parse(this.querySelector('[data-bundle-plans]').textContent);
          this.ready = () => { this.button.disabled = this.busy || typeof window.bndlr?.getCheckoutInfo !== 'function'; };
          this.add = () => this.addMissing();
          this.button.addEventListener('click', this.add);
          document.addEventListener('bundler:loaded', this.ready);
          this.ready();
        }
        disconnectedCallback() {
          this.button.removeEventListener('click', this.add);
          document.removeEventListener('bundler:loaded', this.ready);
        }
        async addMissing() {
          if (this.busy || this.button.disabled) return;
          this.busy = true;
          this.button.disabled = true;
          this.button.textContent = this.dataset.adding;
          this.error.hidden = true;
          const drawer = this.closest('cart-drawer');
          drawer.classList.add('av-cart-busy');
          const checkout = drawer.querySelector('[name="checkout"]');
          checkout.disabled = true;
          try {
            const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!cartResponse.ok) throw new Error('cart');
            const cart = await cartResponse.json();
            const items = this.plans.filter(plan => !cart.items.some(item => Number(item.variant_id) === Number(plan.id) && item.quantity > 0));
            if (!items.length) {
              drawer.querySelector('cart-drawer-items').onCartUpdate();
              return;
            }
            drawer.setActiveElement(drawer.querySelector('.drawer__close'));
            const response = await fetch(routes.cart_add_url, {
              ...fetchConfig(),
              body: JSON.stringify({ items, sections: drawer.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error('add');
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'av-cart-upgrade', cartData: result });
            requestDiscount();
          } catch (error) {
            this.error.textContent = this.dataset.error;
            this.error.hidden = false;
          } finally {
            drawer.classList.remove('av-cart-busy');
            checkout.disabled = drawer.classList.contains('is-empty');
            this.busy = false;
            this.button.textContent = this.label;
            this.ready();
          }
        }
      });
    }
    document.addEventListener('bndlr:bundle_added_to_cart', () => {
      const drawer = document.querySelector('cart-drawer.av-cart-drawer');
      if (!drawer) return;
      fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, { cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error('sections');
          return response.json();
        })
        .then(sections => {
          const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          drawer.classList.toggle('is-empty', parsed.querySelector('cart-drawer').classList.contains('is-empty'));
          drawer.renderContents({ sections });
          requestDiscount();
        })
        .catch(() => { window.location.href = routes.cart_url; });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["av-plan-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-plan-purchase')) {
    customElements.define('av-plan-purchase', class extends HTMLElement {
      connectedCallback() {
        this.primary = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.button = this.querySelector('button');
        this.form = this.primary?.form;
        if (!this.primary || !this.form || !('IntersectionObserver' in window)) return;
        this.error = this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.cartOverlays = [...document.querySelectorAll('#cart-notification, cart-drawer')];
        this.onChange = () => this.update();
        this.onClick = () => { this.stickySubmitted = true; };
        this.button.addEventListener('click', this.onClick);
        this.mobile.addEventListener('change', this.onChange);
        this.intersections = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === this.primary) this.pastPrimary = entry.boundingClientRect.bottom <= 0;
            else this.footerVisible = entry.isIntersecting;
          }
          this.update();
        });
        this.intersections.observe(this.primary);
        const footer = document.querySelector('footer');
        if (footer) this.intersections.observe(footer);
        this.mutations = new MutationObserver(() => {
          if (this.stickySubmitted && this.error && !this.error.hidden) {
            this.stickySubmitted = false;
            this.error.setAttribute('tabindex', '-1');
            this.error.scrollIntoView({ block: 'center', behavior: 'instant' });
            this.error.focus({ preventScroll: true });
          }
          this.update();
        });
        this.mutations.observe(this.primary, { attributes: true, childList: true, subtree: true });
        if (this.error) this.mutations.observe(this.error, { attributes: true, attributeFilter: ['hidden'] });
        for (const overlay of this.cartOverlays) this.mutations.observe(overlay, { attributes: true, attributeFilter: ['class', 'open'] });
        this.update();
      }
      update() {
        const busy = this.primary.getAttribute('aria-disabled') === 'true' || this.primary.classList.contains('loading');
        this.button.disabled = this.primary.disabled || busy;
        this.button.textContent = busy ? this.dataset.adding : this.primary.querySelector('span').textContent.trim();
        this.button.setAttribute('aria-busy', String(busy));
        const overlayOpen = this.cartOverlays.some(el => el.classList.contains('active') || el.hasAttribute('open'));
        this.hidden = !this.mobile.matches || !this.pastPrimary || this.footerVisible || overlayOpen;
        document.body.classList.toggle('av-plan-sticky-visible', !this.hidden);
      }
      disconnectedCallback() {
        this.intersections?.disconnect();
        this.mutations?.disconnect();
        this.mobile?.removeEventListener('change', this.onChange);
        this.button?.removeEventListener('click', this.onClick);
        document.body.classList.remove('av-plan-sticky-visible');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["av-project-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-project-gallery')) {
    customElements.define('av-project-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.stage = this.querySelector('[data-gallery-stage]');
        this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
        this.buttons = [...this.querySelectorAll('[data-gallery-index]')];
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.position = this.querySelector('[data-gallery-position]');
        this.positionPattern = this.position.textContent.trim();
        this.caption = this.querySelector('.av-gallery-caption');
        this.originalCaption = this.caption.textContent;
        this.thumbnails = this.querySelector('.av-gallery-thumbnails');
        this.index = 0;
        this.stage.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(Math.round(this.stage.scrollLeft / this.stage.clientWidth)), 80);
        }, { passive: true, signal });
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.go(index), { signal });
          button.addEventListener('keydown', event => this.onKey(event, index, true), { signal });
        });
        this.stage.addEventListener('keydown', event => {
          if (event.target === this.stage) this.onKey(event, this.index, false);
        }, { signal });
        this.previous.addEventListener('click', () => this.go(this.index - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.index + 1), { signal });
        this.querySelector('[data-gallery-play]')?.addEventListener('click', () => {
          const video = this.querySelector('[data-gallery-video]');
          if (video.querySelector('iframe')) return;
          video.appendChild(video.querySelector('template').content.cloneNode(true));
          video.classList.add('is-playing');
          video.querySelector('iframe').focus();
        }, { signal });
        this.observer = new ResizeObserver(() => {
          this.stage.scrollTo({ left: this.index * this.stage.clientWidth, behavior: 'instant' });
        });
        this.observer.observe(this.stage);
        this.update(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        clearTimeout(this.scrollTimer);
      }
      onKey(event, index, moveFocus) {
        let target;
        if (event.key === 'ArrowRight') target = index + 1;
        if (event.key === 'ArrowLeft') target = index - 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.slides.length - 1;
        if (target === undefined) return;
        event.preventDefault();
        target = Math.max(0, Math.min(target, this.slides.length - 1));
        this.go(target);
        if (moveFocus) this.buttons[target].focus({ preventScroll: true });
      }
      go(index) {
        index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.update(index);
        clearTimeout(this.scrollTimer);
        this.stage.scrollTo({ left: index * this.stage.clientWidth, behavior: 'instant' });
      }
      update(index) {
        if (!Number.isFinite(index)) return;
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', i === this.index));
        this.slides.forEach((slide, i) => {
          slide.inert = i !== this.index;
          slide.setAttribute('aria-hidden', i !== this.index);
          if (i !== this.index) {
            const video = slide.querySelector('[data-gallery-video]');
            video?.querySelector('iframe')?.remove();
            video?.classList.remove('is-playing');
          }
        });
        this.caption.textContent = this.index === 0 ? this.originalCaption : this.slides[this.index].getAttribute('aria-label');
        const selected = this.buttons[this.index];
        if (selected.offsetLeft < this.thumbnails.scrollLeft) this.thumbnails.scrollLeft = selected.offsetLeft;
        if (selected.offsetLeft + selected.offsetWidth > this.thumbnails.scrollLeft + this.thumbnails.clientWidth) this.thumbnails.scrollLeft = selected.offsetLeft + selected.offsetWidth - this.thumbnails.clientWidth;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index === this.slides.length - 1;
        this.position.textContent = this.positionPattern.replace(/^1(?=\D)/, String(this.index + 1));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
